import { useLayoutEffect, useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  // Disable browser's automatic scroll restoration once on mount
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useLayoutEffect(() => {
    if (window.location.hash) return; // honour #anchor links

    // Temporarily neutralise smooth scrolling so jump is instant
    const html = document.documentElement;
    const prev = html.style.scrollBehavior;
    html.style.scrollBehavior = "auto";

    // Multi-frame scroll to defeat any async content height shifts
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;

    const raf1 = requestAnimationFrame(() => {
      window.scrollTo(0, 0);
      const raf2 = requestAnimationFrame(() => {
        window.scrollTo(0, 0);
        html.style.scrollBehavior = prev;
      });
      // store on window so cleanup can cancel
      window.__scrollRaf2 = raf2;
    });

    return () => {
      cancelAnimationFrame(raf1);
      if (window.__scrollRaf2) cancelAnimationFrame(window.__scrollRaf2);
      html.style.scrollBehavior = prev;
    };
  }, [pathname]);

  return null;
}
